import React, { Component } from 'react';
import {
  Dimensions,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { connect } from 'react-redux';
import { history } from 'react-router-dom';
import fileDownload from 'js-file-download';
import _ from 'lodash';

import Icon from '../common/Icon';
import APIClient from '../utils/APIClient';
import UserManager from '../utils/UserManager';
import Utils from '../utils/Utils';

class MenuList extends Component {

  constructor (props) {
    super(props);

    const menuList = [];
    const homeMenu = {
      id: 'home',
      title: 'Trang chủ',
      icon: {
        type: 'FontAwesome',
        name: 'home',
        size: 28,
        color: '#ffffff',
      },
      submenuList: [
        {
          id: 'orders',
          path: '/',
          title: 'Toàn bộ đơn',
          icon: {
            type: 'FontAwesome',
            name: 'files-o',
            size: 24,
            color: '#ffffff',
          },
        }],
    };
    menuList.push(homeMenu);

    const usersMenu = {
      id: 'users',
      title: 'Người dùng',
      icon: {
        type: 'FontAwesome',
        name: 'users',
        size: 24,
        color: '#ffffff',
      },
      submenuList: [],
    };

    const manager = UserManager.getInstance();
    if (manager.isAdmin()) {
      homeMenu.submenuList.push({
        id: 'confirmedOrders',
        path: '/orders/confirmed',
        title: 'Danh sách đơn chốt',
        icon: {
          type: 'FontAwesome',
          name: 'files-o',
          size: 24,
          color: '#ffffff',
        },
      });

      usersMenu.submenuList.push({
        id: 'partners',
        path: '/partners',
        title: 'Danh sách đối tác',
        icon: {
          type: 'FontAwesome',
          name: 'users',
          size: 24,
          color: '#ffffff',
        },
      });
    }
    if (manager.isAdmin() || manager.isPartner()) {
      usersMenu.submenuList.push({
        id: 'agencies',
        path: '/agencies',
        title: 'Danh sách đại lý',
        icon: {
          type: 'FontAwesome',
          name: 'users',
          size: 24,
          color: '#ffffff',
        },
      });
    }

    if (manager.isPartner()) {
      usersMenu.submenuList.push({
        id: 'create-agency',
        path: '/create-agency',
        title: 'Đăng kí đại lý',
        icon: {
          type: 'FontAwesome',
          name: 'plus-circle',
          size: 24,
          color: '#ffffff',
        },
      });
    }

    if (!_.isEmpty(usersMenu.submenuList)) {
      menuList.push(usersMenu);
    }

    if (manager.isAdmin()) {
      const adminMenu = {
        id: 'admin',
        title: 'Admin',
        icon: {
          type: 'FontAwesome',
          name: 'user-plus',
          size: 24,
          color: '#ffffff',
        },
        submenuList: [
          {
            id: 'prepay',
            path: '/prepay',
            title: 'Sinh mã trả trước',
            icon: {
              type: 'FontAwesome',
              name: 'money',
              size: 30,
              color: '#ffffff',
            },
          },
          {
            id: 'raw',
            title: 'Sinh file raw',
            icon: {
              type: 'Ionicons',
              name: 'md-download',
              size: 24,
              color: '#ffffff',
            },
          },
        ],
      };
      menuList.push(adminMenu);
    }

    menuList.push({
      id: 'notifications',
      path: '/notifications',
      title: 'Thông báo',
      icon: {
        type: 'FontAwesome',
        name: 'bell',
        size: 24,
        color: '#ffffff',
      },
    });
    menuList.push({
      id: 'me',
      path: '/me',
      title: 'Tài khoản',
      icon: {
        type: 'FontAwesome',
        name: 'user',
        size: 26,
        color: '#ffffff',
      },
    });

    this.state = {
      menuList: menuList,
    };
  }

  componentWillMount () {
  };

  componentWillUnmount () {
    window.removeEventListener('resize', this._handleWindowResize);
  };

  componentDidMount () {
    this._handleWindowResize();
    window.addEventListener('resize', this._handleWindowResize);
  }

  _handleWindowResize = () => {
    this.setState({windowWidth: Dimensions.get('window').width});
  };

  _handleClick = (data) => {
    const {id} = data;
    if (id === 'raw') {
      this._generateRawFile();
      return;
    }

    const {onClick} = this.props;
    if (onClick) {
      onClick(data);
    }
  };

  _generateRawFile = async () => {
    const {response, error} = await APIClient.GET('/admin/raw', null);
    if (response) {
      // console.log('generate raw file response: ', response);
      const filename = `report-${Utils.dateToString(new Date(),
        'DD-MM-YYYY HH:mm')}.csv`;
      fileDownload('\ufeff' + response, filename);
    }
    if (error) {
      console.log('generate raw file error: ', error);
    }
  };

  render () {
    const {menuList, windowWidth} = this.state;
    return (
      <View
        className='top-menu'
        style={styles.container}>
        {menuList.map((data, index) =>
          <MenuItem
            key={index}
            data={data}
            menuLevel={1}
            windowWidth={windowWidth}
            onClick={this._handleClick}/>,
        )}
      </View>
    );
  }
}

class MenuItem extends Component {

  constructor (props) {
    super(props);

    this.state = {
      submenu: undefined,
      submenuExpaned: false,
    };
  }

  componentWillUnmount () {
    document.addEventListener('mousedown', this._handleWindowClick, false);
  };

  componentDidMount () {
    document.addEventListener('mousedown', this._handleWindowClick, false);
  }

  _handleWindowClick = (e) => {
    if (this.state.submenuExpaned !== true) {
      return;
    }
    let node = e.target;
    while (node != null) {
      if ('classList' in node && 'contains' in node.classList
        && (node.classList.contains('sub-menu'))) {
        return;
      }
      node = node.parentNode;
    }
    this._triggerSubmenu(false);
  };

  _handleClick = (data) => {
    this._triggerSubmenu(
      !_.isEmpty(data.submenuList) && !this.state.submenuExpaned);

    const {onClick} = this.props;
    if (_.isEmpty(data.submenuList) && onClick) {
      onClick(data);
    }
  };

  _triggerSubmenu = (value) => {
    if (!_.isEmpty(this.props.data.submenuList)) {
      this.setState({
        submenuExpaned: value,
      });
    }
  };

  _getStyle = () => {
    const {menuLevel} = this.props;
    return {
      top: (menuLevel == 1) ? 45 : 0,
      left: 200 * (menuLevel - 1),
      backgroundColor: '#4caf50',
      minWidth: 250,
      position: 'absolute',
      boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
      zIndex: menuLevel + 1000,
    };
  };

  render () {
    const {data, menuLevel, windowWidth} = this.props;
    const {submenuExpaned} = this.state;
    const {title, icon, submenuList} = data;
    return (<View>
        <TouchableOpacity
          activeOpacity={0.75}
          onPress={() => this._handleClick(data)}
          style={styles.item}>
          <Icon
            {...icon}
            style={styles.itemIcon}/>
          {((windowWidth > 600 && menuLevel < 2) || menuLevel > 1) &&
          <Text
            style={styles.itemText}>
            {title}
          </Text>}

        </TouchableOpacity>

        {submenuExpaned && <View style={this._getStyle()} className="sub-menu">
          {submenuList.map((data, index) =>
            <MenuItem
              key={index}
              data={data}
              windowWidth={windowWidth}
              menuLevel={menuLevel + 1}
              onClick={() => this._handleClick(data)}/>,
          )}
        </View>}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    height: 45,
    flexDirection: 'row',
    backgroundColor: '#4CAF50',
    borderBottomColor: '#eeeeee',
    borderBottomWidth: 2,
    zIndex: 1000,
  },
  item: {
    flexDirection: 'row',
    height: 44,
    paddingHorizontal: 10,
    alignItems: 'center',
    borderRightColor: '#ffffff',
    borderRightWidth: 1,
  },
  itemIcon: {},
  itemText: {
    marginLeft: 5,
    color: '#fff',
    fontSize: 16,
    fontWeight: '300',
    marginRight: 5,
  },

  submenuBackground: {
    top: 0,
    left: 0,
    position: 'fixed',
    width: '100%',
    zIndex: 2,
    height: 1000,
  },
  menuBox: {
    top: 45,
    left: 0,
    position: 'absolute',
    backgroundColor: '#4caf50',
    minWidth: 300,
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
    zIndex: 1000,
  },
});

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuList);



// WEBPACK FOOTER //
// ./src/menu/MenuList.web.js